import * as axios from "axios";
import CONFIG from "../../config";
import { getAuthHeader } from "../../utils";

//add university
export const getleads = (model) => {
  const url = `${CONFIG.BASE_URL}/lead/common-lead-list`;
  return axios.post(url, model, getAuthHeader()).then((response) => {
    return response.data;
  });
};
